import axios from 'axios';

const api = axios.create({
  //baseURL: 'http://localhost:3000/api',
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor — agrega el token automáticamente a cada petición
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('DOMINIUM_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor — maneja errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('DOMINIUM_token');
      localStorage.removeItem('DOMINIUM_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
